export var defined = function defined(x) {
  return x !== undefined && x != null && !Number.isNaN(x);
};